export const getBoxShadow = (color: string) => `0 0 0 2px ${color}`;
